import React, {useState, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"
import {jsonResponseHandler} from '../utils/FetchHelper'
import {closePopup, hideLoadingPopup, showLoadingPopup, showSkinSavePopup} from "../actions/popup"
import LoadingBox from "../components/common/LoadingBox"
import CurrentSkin from "../components/design/skin/CurrentSkin"
import SkinPopupLayer from "../components/design/skin/SkinPopupLayer"
import LoadErrorBox from "../components/common/LoadErrorBox"
import * as InitStatus from '../constants/common/InitializationStatus'
import SkinListHeader from "../components/design/skin/SkinListHeader"
import SkinListTitle from "../components/design/skin/SkinListTitle"
import SkinList from "../components/design/skin/SkinList"
import {addPrefix} from "../utils/UriUtil"
import {TISTORY} from "../constants/Service"
import {receiveSkinInfo} from "../actions/design/skin"
import {CONFIRM_CHANGE_SKIN_MSG} from "../components/design/skin/SkinMsg";

function UserSkin({currentSkin, onSetSkin, daumblogCustomSkin}) {

  function handleSetUserSkin(e) {
    e.preventDefault();
    onSetSkin(`customize/${daumblogCustomSkin}`)
  }

  function handleSetNewSkin(e) {
    e.preventDefault()
    window.scrollTo(0, 0)
  }

  if (currentSkin.isCustomized) {
    return (
      <div className="wrap_set">
        <div className="desc_invite">
          <p className="txt_skinadd">더 보기 편하고 쓰기 좋은 새로운 스킨이 많이 나왔습니다.<br/> 블로그를 새롭게 꾸며 보세요.</p>
          <a href="#" className="btn_preview" onClick={handleSetNewSkin}>새 스킨 사용하기</a>
        </div>
      </div>
    )
  } else {
    return (
      <a href="#" className="link_prev" onClick={handleSetUserSkin}>구 스킨 사용</a>
    )
  }
}


export default function SkinListApp({history}) {
  const dispatch = useDispatch()

  function handleShowLoadingPopup(loadingPopupMessage) {
    dispatch(showLoadingPopup(loadingPopupMessage))
  }

  function handleHideLoadingPopup() {
    dispatch(hideLoadingPopup())
  }

  const [initialized, setInitialized] = useState(InitStatus.INIT_READY)
  const [currentSkin, setCurrentSkin] = useState(null)
  const [skinList, setSkinList] = useState([])
  const [sort, setSort] = useState('popular')
  const [filter, setFilter] = useState('all')
  const [size, setSize] = useState(0);
  const [daumblogCustomSkin, setDaumblogCustomSkin] = useState('');

  const isTistoryService = window.Config.service === TISTORY

  useEffect(() => {

    loadSkinData(true);

    // 다음블로그용 CustomSkinName (archive)
    if (!isTistoryService) loadDaumblogCustomSkin();

  }, []);


  function loadDaumblogCustomSkin() {
    fetch(addPrefix(`/manage/design/skin/archivelist.json`), {
      credentials: 'include',
      method: 'get',
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {

        if(data && data.archiveList.length > 0){
          setDaumblogCustomSkin(data.archiveList[0].folderName);
        }

      })
      .catch(e => {
        console.error(e)
      });
  }

  function loadSkinData(useStatus) {
    if (useStatus) {
      setInitialized(InitStatus.INIT_DOING)
    }
    fetch(addPrefix("/manage/design/skin/skinlist.json"), {
      credentials: 'include',
      headers: {'Content-Type': 'application/json'}
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        setCurrentSkin(data.currentSkin)
        setSkinList(data.skinList)
        setSize(data.skinList.length)
        if (useStatus) {
          setInitialized(InitStatus.INIT_SUCCESS)
        }
      })
      .catch(e => {
        console.error(e);
        if (useStatus) {
          setInitialized(InitStatus.INIT_FAIL)
        }
      })
  }

  function handleArchive(e) {
    e.preventDefault();
    e.stopPropagation();

    dispatch(showSkinSavePopup(
      '스킨 보관',
      '보관 시 HTML/CSS 편집 및 사이드바 설정 등의 정보까지 저장됩니다. 스킨은 최대 30개까지 저장할 수 있습니다.',
      archiveName => {
        dispatch(closePopup())
        handleShowLoadingPopup('보관 중입니다.');

        // 이름이 겹치는 지 확인
        fetch(addPrefix(`/manage/design/skin/checkArchiveNameAvailability.json?archiveName=${archiveName}`), {
          method: 'get',
          credentials: "include",
        })
          .then(jsonResponseHandler(dispatch))
          .then(r => r.json())
          .then(data => {
            let ok = data['DUPLICATED'] ? confirm("같은 이름의 저장된 스킨이 있습니다.\n스킨을 덮어씌우겠습니까?") : true
            if (ok) {
              let formdata = new FormData()
              formdata.append("skinname", archiveName)
              formdata.append("originalname", currentSkin.name)

              fetch(addPrefix("/manage/design/skin/archive.json"), {
                method: 'post',
                credentials: "include",
                body: formdata
              })
                .then(jsonResponseHandler(dispatch))
                .then(r => r.json())
                .then(data => {
                  handleHideLoadingPopup();
                  loadSkinData(false)
                })
                .catch(e => {
                  console.error(e)
                  handleHideLoadingPopup();
                })
            } else {
              handleHideLoadingPopup();
            }
          })
          .catch(e => {
            handleHideLoadingPopup();
            console.error(e)
          })
      }
    ))
  }

  function handleSetFilter(filter) {
    let filtered = skinList.filter(a => {
      return (filter === 'all' || filter === a.layout || (filter == '2' && a.layout == 'etc') || (filter === 'EDITABLE_MENU' && a.isEditableMenu == '1') || (filter === 'SKIN_WIZARD' && a.wizard == '1'))
    })

    setFilter(filter)
    setSize(filtered.length)
  }

  function handleSetSort(sort) {
    setSort(sort)
  }

  function handleSetSkin(skinName) {

    if(!confirm(CONFIRM_CHANGE_SKIN_MSG))
      return false;


    handleShowLoadingPopup('적용 중입니다.');
    let formdata = new FormData()
    formdata.append("name", skinName)
    fetch(addPrefix("/manage/design/skin/set.json"), {
      credentials: 'include',
      method: 'post',
      body: formdata
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        dispatch(receiveSkinInfo(data))
        handleHideLoadingPopup()
        loadSkinData(false)
        window.scrollTo(0, 0)
      })
      .catch(e => {
        console.error(e)
        handleHideLoadingPopup();
      });
  }

  function handleReset() {
    setSort('popular')
    setFilter('all')
    setSize(skinList.length)
  }

  return (
    <div className="inner_article decoration_article">
      <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
      {(initialized === InitStatus.INIT_DOING) && <LoadingBox/>}
      {(initialized === InitStatus.INIT_FAIL) && <LoadErrorBox retry={() => loadSkinData(true)}/>}
      {(initialized === InitStatus.INIT_SUCCESS) &&
      <div className="blog_skin">
        {isTistoryService &&
        <>
          <h3 className="tit_cont">사용중인 스킨</h3>
          <CurrentSkin currentSkin={currentSkin} handleArchive={handleArchive}/>
        </>
        }

        <SkinListTitle
          filter={filter} size={size} history={history}
          onReset={handleReset}
        />
        {isTistoryService &&
        <SkinListHeader
          filter={filter} sort={sort} size={size}
          onChangeFilter={handleSetFilter}
          onChangeSort={handleSetSort}
        />
        }

        <SkinList
          filter={filter} sort={sort}
          skinList={skinList} currentSkin={currentSkin}
          onSet={handleSetSkin} onChangeFilter={handleSetFilter}
        />

        {!isTistoryService && <UserSkin currentSkin={currentSkin} onSetSkin={handleSetSkin} daumblogCustomSkin={daumblogCustomSkin}/>}
      </div>
      }
      <SkinPopupLayer refetch={() => loadSkinData(false)}/>
    </div>
  )
}

